import React from 'react';
import { BookOpenIcon, DumbbellIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const blocks = [{
  icon: BookOpenIcon,
  label: 'Theory',
  title: 'Understand the why behind every drill',
  description: 'The science, the biomechanics, and the reason each exercise works — explained in plain language so you can answer any athlete’s question with confidence.'
}, {
  icon: DumbbellIcon,
  label: 'Practice',
  title: 'Exercises ready to run today',
  description: 'Step-by-step drills, sessions, reps, and cues laid out to use exactly as they are. Open the PDF at the track and coach straight from the page.'
}];
export function TheoryPractice() {
  return <section className="w-full bg-carbon-800 py-16 sm:py-20 lg:py-28" aria-labelledby="learn-heading" data-id="element-205" data-mp="28jhkpdhkyfba">
      <div className="mx-auto max-w-content px-4 sm:px-6" data-id="element-206" data-mp="353qb9t6s76cj">
        <SectionHeading id="learn-heading" eyebrow="Theory + practice" title={<>
              You get both halves:
              <span className="block text-mint" data-id="element-208" data-mp="e7k32f3sn083">learn it and teach it</span>
            </>} subtitle="Ideal so you truly learn the method yourself — and then deliver it like a professional in front of your athletes." data-id="element-207" data-mp="30ax6x6f8600z" />

        <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-2" data-id="element-209" data-mp="9dplpibnuxc6">
          {blocks.map(block => {
          const Icon = block.icon;
          return <div key={block.label} className="flex h-full flex-col rounded-xl border border-carbon-line bg-carbon-900 p-7 sm:p-8" data-id="element-210" data-mp="dt6067918t9">
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-mint/10" data-id="element-211" data-mp="3ho10mkadjoru">
                  <Icon className="h-5 w-5 text-mint" aria-hidden="true" data-id="element-212" data-mp="3mmudcahu7bqy" />
                </span>
                <p className="mt-5 text-[11px] font-bold uppercase tracking-[0.2em] text-mint" data-id="element-213" data-mp="1fsgwcdql5wje">
                  {block.label}
                </p>
                <h3 className="mt-2 font-display text-xl uppercase leading-tight text-paper sm:text-2xl" data-id="element-214" data-mp="1jcqzmj1mjsff">
                  {block.title}
                </h3>
                <p className="mt-3 leading-relaxed text-paper-dim" data-id="element-215" data-mp="1efqty98osrou">{block.description}</p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}